import React, { useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { Title, Modal } from '@common/components';
import { popIn } from '@common/utils/services';
import IncomeForm from '../Form';
import {
	fetchTransaction,
	updateTransactionIncome,
} from '@common/resources/Transaction/actions';
import { useIntl } from 'react-intl';
import isEmpty from 'lodash.isempty';

const Update = (props) => {
	const {
		fetchTransaction,
		transaction,
		updateTransactionIncome,
		visible,
		onCancel,
	} = props;
	const intl = useIntl();

	useEffect(() => {
		const fetchData = async () => {
			await fetchTransaction(visible);
		};
		visible && fetchData();
	}, [fetchTransaction, visible]);

	const handleSubmit = useCallback(
		(data) => {
			return updateTransactionIncome(transaction._id, data)
				.then((response) => {
					popIn(
						'success',
						intl.formatMessage({
							id: 'message.success.income.update',
							defaultMessage:
								'An existing Income entry has been successfully updated',
						})
					);

					onCancel && onCancel();
				})
				.catch((err) => Promise.reject(err));
		},
		[transaction]
	);

	return (
		<Modal visible={visible} onCancel={() => onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.update.Income',
					defaultMessage: 'Update Income',
				})}
			</Title>
			{!isEmpty(transaction) && (
				<IncomeForm
					data={transaction}
					onSubmit={handleSubmit}
					{...props}
				/>
			)}
		</Modal>
	);
};

const mapStateToProps = ({
	transaction,
	modules,
	cellGroup,
	event,
	facility,
	ministry,
	mission,
	organization,
	prayer,
	testimony,
}) => {
	return {
		transaction,
		modules,
		cellGroup,
		event,
		facility,
		ministry,
		mission,
		organization,
		prayer,
		testimony,
	};
};

export default connect(mapStateToProps, {
	fetchTransaction,
	updateTransactionIncome,
})(Update);
